import ErrorImage from '../../assets/images/info-triangle.webp';
import useTranslation from '../../localization/i18n.context';
import { CloseWebviewEvent } from '../../sdk/close.webview.event';
import InfoFeedbackScreen from '../../components/shared/InfoFeedbackScreen/InfoFeedbackScreen';
import NavigationUtils from '../../utils/navigation.utils';

const restartFlow = () => {
  NavigationUtils.navigate(NavigationUtils.Routes.CARD_ACTIVATION);
};

const closeView = () => {
  CloseWebviewEvent.finishWithError();
};

const CardActivationStatusType = {
  TRY_AGAIN: 'try-again',
  MAX_ATTEMPTS: 'max-attempts',
};

const CardActivationStatusConfig = {
  [CardActivationStatusType.TRY_AGAIN]: {
    image: ErrorImage,
    title: 'Ooops!',
    subtitle: 'Invalid card number or activation code, please try again',
    ctaText: 'Try Again',
    ctaAction: restartFlow,
    onCloseClick: restartFlow,
  },

  [CardActivationStatusType.MAX_ATTEMPTS]: {
    image: ErrorImage,
    title: 'Ooops!',
    subtitle: 'Too many attempts. Try again in 5 minutes.',
    ctaText: 'Ok',
    ctaAction: closeView,
    onCloseClick: restartFlow,
  },
};

export default function CardActivationStatusPage(props) {
  const { t } = useTranslation();
  const { type } = props;

  const data = CardActivationStatusConfig[type];

  return (
    <>
      {data && (
        <InfoFeedbackScreen
          onCloseClick={data.onCloseClick}
          image={data.image}
          title={t(data.title)}
          subtitle={t(data.subtitle)}
          ctaAction={data.ctaAction}
          ctaText={t(data.ctaText)}
        />
      )}
    </>
  );
}

CardActivationStatusPage.Type = CardActivationStatusType;
